import * as React from 'react';

/**
 * The summary card's band: the event's cover, or the spark gradient when it has none.
 *
 * `object-cover` in a box of the band's own heights (72px on a phone, 120px from `lg`), so a
 * cover of any shape fills it the way the event page's banner is filled rather than letterboxing.
 * The gradient stays behind the image as its ground, which is what a member sees for the moment
 * before a presigned address loads. `alt` is the organizer's description (`EVT-008` AC-2) and
 * `""` for an older record written before the field was required, the event page's own rule: no
 * description means the image adds nothing a reader can act on, and inventing one is worse.
 */
export function CheckoutCoverBand({
  cover,
}: {
  readonly cover: { readonly url: string; readonly description: string | null } | null;
}): React.ReactElement {
  if (cover === null) {
    return <div className="h-[72px] bg-spark lg:h-[120px]" aria-hidden />;
  }
  return (
    <div className="relative h-[72px] overflow-hidden bg-spark lg:h-[120px]">
      <img
        src={cover.url}
        alt={cover.description ?? ''}
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
  );
}
